import * as React from 'react';

import { useAppContext } from '../../contexts/AppContext';

import styled from '@emotion/styled';

import { useRouter } from 'next/router';
import { ArrowBackIos } from '@mui/icons-material';
import Image, { ImageLoaderProps } from 'next/image';

import { Rnd } from 'react-rnd';

const RedirectBackButtonContainer = styled('div')(({ theme }) => ({
  display: 'none',
  position: 'absolute',
  width: '100vw',
  right: '10px',
  top: '10px',
  [theme.breakpoints.down(800)]: {
    display: 'flex',
    justifyContent: 'end',
  },
  svg: {
    position: 'absolute',
    left: '10px',
    top: '8px',
    fill: 'white',
  },
}));

const RedirectImage = styled(Image)(() => ({
  objectFit: 'cover',
  width: '100%',
  height: '100%',
}));

const RndContainer = styled(Rnd)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1201,
  cursor: 'pointer',
}));

export const RedirectBackButton = () => {
  const appContext = useAppContext();
  const { componentOptions } = appContext.useConfig();

  const redirectImage = componentOptions?.component_gamescreen_redirect_back_button_image;
  const redirectUrl = componentOptions?.component_gamescreen_redirect_back_button_redirect_url;

  const [startCoord, setStartCoord] = React.useState<{ x: number; y: number }>();

  const router = useRouter();

  const handleRedirect = () => {
    router.push(redirectUrl || '/');
  };

  return (
    <RndContainer
      className="12313123123"
      bounds="parent"
      default={{
        x: 0,
        y: 0,
        width: 72,
        height: 72,
      }}
      onDragStart={(_, { x, y }) => setStartCoord({ x, y })}
      onDragStop={(_, { x, y }) => {
        if (startCoord?.x === x && startCoord?.y === y) {
          handleRedirect();
        }
      }}
    >
      <RedirectBackButtonContainer>
        {redirectImage ? (
          <RedirectImage
            loader={({ src }: ImageLoaderProps) => src}
            unoptimized={true}
            width={54}
            height={54}
            src={`${redirectImage}`}
            alt={'back-image'}
          />
        ) : (
          <ArrowBackIos />
        )}
      </RedirectBackButtonContainer>
    </RndContainer>
  );
};
